import MotivoEtapaPCPModel from "../models/pcp/motivoEtapaPCPModel";

import { IService } from "./base/iService";

export default class MotivoEtapaPCPService extends IService<MotivoEtapaPCPModel> {
    constructor() {
        super("MotivoEtapaPCP");
    }
}